<template>
  <AppHeaderDropdown right no-caret v-if="$store.state.currentUser.id">
    <template slot="header">
      <i class="icon-envelope-letter"></i>
      <b-badge pill variant="info">{{ obj ? obj.length : 0 }}</b-badge>
    </template>
    <template slot="dropdown">
      <b-list-group style="width:400px">
        <b-list-group-item href="#" class="flex-column align-items-start" variant="primary">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1"><small>Mensagens</small></h5>
            <small></small>
          </div>
          <!--
          <p class="mb-1">
            Você tem 7 mensagens
          </p>
          -->
        </b-list-group-item>
        <b-list-group-item href="#" class="flex-column align-items-start" v-for="item in obj" :key="item.id">
          <div class="message">
            <div class="pt-3 mr-3 float-left">
              <div class="avatar">
                <img :src="item.message.user.avatar ? item.message.user.avatar : 'img/avatars/admin.png'" class="img-avatar">
                <span class="avatar-status bg-success" v-show="false"></span>
              </div>
            </div>
            <div>
              <small class="text-muted">{{ item.message.user.name }}</small>
              <small class="text-muted float-right mt-1">{{ $utils.localDateShortTime(item.message.messageDate) }}</small>
            </div>
            <div class="text-truncate font-weight-bold" v-show="item.message.subject && item.message.subject.length > 0"><span class="fa fa-exclamation text-danger" v-show="false"></span> {{ item.message.subject }}</div>
            <div class="small text-muted text-truncate">{{ $utils.parseHtml(item.message.bodyText) }}</div>
          </div>
        </b-list-group-item>
        
        <b-list-group-item href="#" class="flex-column align-items-start"  variant="secondary">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1 text-center"><small>Visualizar todas as mensagens</small></h5>
          </div>
        </b-list-group-item>

      </b-list-group>

     
    </template>
  </AppHeaderDropdown>
</template>
<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import axios from "axios";

export default {
  name: 'DefaultHeaderDropdownMssgs',
  components: {
    AppHeaderDropdown
  },
  props: {
    obj: Array
  },
  data: () => {
    return {

      messages: [
        /*
        {
          "id" : 21312,
          "from" : "Adriana Takamura",
          "online" : false,
          "date" : "11/04/2022 13:52",
          "title" : "Título da mensagem",
          "message" : "Corpo da mensagem Corpo da mensagem Corpo da mensagem Corpo da mensagem",
          "avatar" : "img/avatars/5.jpg",
          "class" : "bg-warning",
          "important" : false,
        },
      
        */
        
      ],
      
      }
  },
  methods: {

  }
  
}
</script>
<style scoped>

.navbar-default .navbar-nav .open .dropdown-menu-lg > .active > a,
.navbar-default .navbar-nav .open .dropdown-menu-lg > .active > a:hover,
.navbar-default .navbar-nav .open .dropdown-menu-lg > .active > a:focus {
    color: #555555;
    background-color: #e7e7e7;
}

</style>